import React from 'react';
import PropTypes from 'prop-types';
import SellerIcon from 'core/icons/SellerIcon';
import TruncatedContent from 'core/components/TruncatedContent';
import { ContactSeller } from 'core/components/ContactSeller';
import {
	Wrapper,
	FooterContainer,
	ReplyHeader,
	ReplyName,
	ReplyNameText,
	ReplyDate,
} from './merchantReplyStyles';
import { QuestionTypes } from 'core/utils';


const MerchantReply = ({ children, footer, postDate, displayName, verb, visibleWordCount, onToggle, triggerLogin, isLoggedIn }) => {
	return (
		<Wrapper>
			<ReplyHeader>
				<SellerIcon />
				<ReplyName>
					<ReplyNameText>{displayName} {verb}...</ReplyNameText>
					<ReplyDate>{postDate}</ReplyDate>
				</ReplyName>
			</ReplyHeader>
			<TruncatedContent visibleWordCount={visibleWordCount} onToggle={onToggle}>
				{children}
			</TruncatedContent>
			<FooterContainer>
				<ContactSeller
					isLoggedIn={isLoggedIn}
					triggerLogin={triggerLogin}
					size="sm"
					label="Contact Seller"
					fontSize="14px"
					questionType={QuestionTypes.pre_purchase}
				/>
				{footer}
			</FooterContainer>
		</Wrapper>
	);
};


MerchantReply.propTypes = {
	children: PropTypes.string.isRequired,
	postDate: PropTypes.string,
	displayName: PropTypes.string,
	verb: PropTypes.string,
	visibleWordCount: PropTypes.number,
	isLoggedIn: PropTypes.bool,
	footer: PropTypes.node,
	onToggle: PropTypes.func,
	triggerLogin: PropTypes.func.isRequired,
};

MerchantReply.defaultProps = {
	verb: 'said',
	visibleWordCount: 125,
	footer: null,
	onToggle: null,
};

export default MerchantReply;
